import { CalendarOutlined, ClockCircleOutlined } from '@ant-design/icons';
import React from 'react';
import { customDate } from '../../helper';
import clsx from 'clsx';

const DueDateBadge = ({ date, completedAt }) => {
  if (!date) return '-';

  const { isOverdue, formattedDate, formattedTime } = customDate(date, completedAt);

  return (
    <div className={clsx('modern-due-date', { 'overdue': isOverdue })}>
      <div className="date-section">
        <CalendarOutlined />
        <span>{formattedDate}</span>
      </div>
      <div className="divider" />
      <div className="time-section">
        <ClockCircleOutlined />
        <span>{formattedTime}</span>
      </div>
    </div>
  );
};

export default DueDateBadge;
